"use strict";
var core_1 = require('@angular/core');
var ng_redux_1 = require('./components/ng-redux');
var dev_tools_1 = require('./components/dev-tools');
function _ngReduxFactory(ngZone) {
    return new ng_redux_1.NgRedux(ngZone);
}
exports._ngReduxFactory = _ngReduxFactory;
var NgReduxModule = (function () {
    function NgReduxModule() {
    }
    NgReduxModule.decorators = [
        { type: core_1.NgModule, args: [{
                    providers: [
                        dev_tools_1.DevToolsExtension,
                        { provide: ng_redux_1.NgRedux, useFactory: _ngReduxFactory, deps: [core_1.NgZone] }
                    ]
                },] },
    ];
    /** @nocollapse */
    NgReduxModule.ctorParameters = function () { return []; };
    return NgReduxModule;
}());
exports.NgReduxModule = NgReduxModule;
;
//# sourceMappingURL=ng-redux.module.js.map


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/venyou-stripe/~/ng2-redux/lib/ng-redux.module.js
// module id = ../../../../ng2-redux/lib/ng-redux.module.js
// module chunks = 3